module.exports = __webpack_public_path__ + "teg/media/SingleModeFTL.39312bb4.jpg";